import React from "react";
import {
  Image as ImageIcon, MessageCircleHeart, Heart, Star, Gift, User, MapPin, Plane,
  Dumbbell, Utensils, Music, PawPrint, Instagram, Youtube, Twitter,
} from "lucide-react";

const MAP = {
  image: ImageIcon, poll: MessageCircleHeart, heart: Heart, star: Star, gift: Gift, user: User,
  pin: MapPin, plane: Plane, gym: Dumbbell, food: Utensils, music: Music, paw: PawPrint,
  instagram: Instagram, youtube: Youtube, x: Twitter,
};

export const Icon = ({ name, filled, ...props }) => {
  const C = MAP[name] || Heart;
  return <C {...props} fill={filled ? "currentColor" : "none"} />;
};

export const CrownIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden>
    <path d="M3 7.5l4.5 4 4.5-7 4.5 7 4.5-4-2 10.5H5L3 7.5z" />
    <circle cx="3" cy="6.5" r="1.6" /><circle cx="12" cy="3.5" r="1.6" /><circle cx="21" cy="6.5" r="1.6" />
    <rect x="5" y="19" width="14" height="2" rx="1" />
  </svg>
);

export const LipsIcon = ({ className }) => (
  <svg viewBox="0 0 32 20" className={className} aria-hidden>
    <path fill="#e2264d" d="M1 9c4-6 8-8 11-6 2 1 3 1 4 0 1 1 2 1 4 0 3-2 7 0 11 6-1 0-2 .5-3 .5H4C3 9.5 2 9 1 9z" />
    <path fill="#c8163c" d="M1 9.5c3 .7 27 .7 30 0-3 6-8 9.5-15 9.5S4 15.5 1 9.5z" />
    <path fill="#ff8fa8" opacity=".6" d="M9 13c3 1.5 11 1.5 14 0-2 2.5-12 2.5-14 0z" />
  </svg>
);

export const InstaGradientIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden>
    <defs>
      <linearGradient id="ig" x1="0" y1="1" x2="1" y2="0">
        <stop offset="0" stopColor="#feda75" /><stop offset=".35" stopColor="#fa7e1e" />
        <stop offset=".65" stopColor="#d62976" /><stop offset="1" stopColor="#962fbf" />
      </linearGradient>
    </defs>
    <rect x="2.5" y="2.5" width="19" height="19" rx="5.5" fill="none" stroke="url(#ig)" strokeWidth="2.2" />
    <circle cx="12" cy="12" r="4.3" fill="none" stroke="url(#ig)" strokeWidth="2.2" />
    <circle cx="17.4" cy="6.6" r="1.3" fill="url(#ig)" />
  </svg>
);
